module.exports = __webpack_public_path__ + "img/135ne.0199aaa2.svg";